import { MEDIA, Middleware } from 'stylis';

/**
 * Replaces @media queries with @container queries
 */
const stylisContainerPlugin: Middleware = (element) => {
  // check if we are dealing with @media query
  if (element.type === MEDIA) {
    element.value = element.value.replace('@media', '@container');
  }
};

Object.defineProperty(stylisContainerPlugin, 'name', { value: 'stylisContainerPlugin' });
export default stylisContainerPlugin;
